/* Publish by EComposer at 2024-07-31 05:36:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6bxtw3sx5vk"]=  window.__ectimmers["ecom-6bxtw3sx5vk"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6bxtw3sx5vk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bxtw3sx5vk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cojmb5gf2n7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cojmb5gf2n7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xac7xxefro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xac7xxefro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynwgblttjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynwgblttjz', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-udbvrddxylq"]=  window.__ectimmers["ecom-udbvrddxylq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-udbvrddxylq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udbvrddxylq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gsp9672tg4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gsp9672tg4p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtsvq6pu7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtsvq6pu7q', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1mou7bgk7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1mou7bgk7r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nv15gzwlqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nv15gzwlqe', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ggvo5qiasyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ggvo5qiasyn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7gxo7hj5em9"]=  window.__ectimmers["ecom-7gxo7hj5em9"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-7gxo7hj5em9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7gxo7hj5em9', settings: {"source":"hosted"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1ly9yqi2op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1ly9yqi2op', settings: {"source":"hosted"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1m6aj158s4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1m6aj158s4w', settings: {"source":"hosted"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}